import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';
import { Button } from '@app/components';
import { subscriptionStatus } from '@app/constants/subscribe';
import {
  enableAutoRenewSubscription, disableAutoRenewSubscription, subscribeSelectedOption,
} from '@app/actions/subscribeActions';

const PackageButton = ({
  option, onButtonClick, disabled,
  isPurchaseInProgress, subscribeSelectedOption,
  disableAutoRenewSubscription, enableAutoRenewSubscription,
}) => {
  const {
    statusId, allowCancel, allowPay, allowRenewal, saleOptionId, optionId,
  } = option;
  const allowRenewalDate = allowRenewal ? new Date(allowRenewal * 1000) : null;
  const allowCancelDate = allowCancel ? new Date(allowCancel * 1000) : null;
  const allowPayDate = allowPay ? new Date(allowPay * 1000) : null;
  const today = new Date();
  const buttonProps = (() => {
    switch (statusId) {
      case subscriptionStatus.ACTIVE:
        return {
          labelId: 'package.renewDisable',
          loading: isPurchaseInProgress,
          onClick: () => disableAutoRenewSubscription(optionId, saleOptionId),
          disabled: !(allowCancelDate && (allowCancelDate.getTime() < today.getTime())),
          longText: true,
        };
      case subscriptionStatus.TERMINATED:
        return {
          labelId: 'package.renewEnable',
          loading: isPurchaseInProgress,
          onClick: () => enableAutoRenewSubscription(optionId),
          disabled: !(allowRenewalDate && (allowRenewalDate.getTime() < today.getTime())),
          longText: true,
        };
      case subscriptionStatus.ORDERED:
        return {
          labelId: 'package.pay',
          onClick: () => subscribeSelectedOption(optionId),
          disabled: !(allowPayDate && (allowPayDate.getTime() < today.getTime())) || isPurchaseInProgress,
          loading: isPurchaseInProgress,
        };
      case subscriptionStatus.PENDING:
      case subscriptionStatus.SUSPENDED:
      case subscriptionStatus.CANCELLED:
      case subscriptionStatus.ID_STATE_DISBARRED:
        return false;
      default:
        return {
          labelId: 'package.select',
          onClick: () => onButtonClick(option),
          disabled,
        };
    }
  })();

  return (
    buttonProps && (
      <Button
        bordered
        textColor={colors.ALIZARIN_CRIMSON}
        backgroundColor={colors.SUPERNOVA}
        {...buttonProps}
      />
    )
  );
};

PackageButton.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  option: PropTypes.oneOfType([PropTypes.object]).isRequired,
  enableAutoRenewSubscription: PropTypes.func.isRequired,
  disableAutoRenewSubscription: PropTypes.func.isRequired,
  subscribeSelectedOption: PropTypes.func.isRequired,
  isPurchaseInProgress: PropTypes.bool,
  onButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
};

PackageButton.defaultProps = {
  isPurchaseInProgress: false,
  onButtonClick: () => {},
  disabled: false,
};

const mapStateToProps = ({ subscribe: { isPurchaseInProgress } }) => ({ isPurchaseInProgress });

const mapDispatchToProps = {
  disableAutoRenewSubscription,
  enableAutoRenewSubscription,
  subscribeSelectedOption,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PackageButton));
